import { useDataFormStore } from "@/stores/form";
import { getArrayOfRules } from "@/utils/getDataForm";
import { NEWEST_BACKEND } from "@/remotes";
import { ref, onMounted, watch } from "vue";
import { debounce } from 'lodash';
import { tabRefreshPackages, tabRefreshTimePickup, getCargoTabKey, getOtherKey } from "@/utils/tabsFunctions";
import { getPackageKey } from "@/utils/tabsFunctions";
import { requiredNeeded } from "@/utils/baseFunctions";

export default {
  props: {
    cargoSpaceTab: Array,
    natures: Array,
  },

  setup() {
    const dataForm = useDataFormStore();

    // Характер груза
    const natures = ref([]);
    const fnatures = ref([]);

    onMounted(async function () {
      // Запрос характера груза
      try {
        const { data } = await NEWEST_BACKEND.get(`/public/cargo-natures`);
        natures.value = data;
        fnatures.value = natures.value
      } catch (e) {
        console.log(e);
      }
    });

    

    let typeOfPackagings = [];
    typeOfPackagings[0] = ref([]);

    const optionsWhoPaysTheRansom = [
      {
        value: "0",
        label: "За счёт средств клиента",
      },
      {
        value: "1",
        label: "За счет ТК ЛУЧ",
      },
    ];

    const communications = [
      {
        value: "Email",
        label: "Email",
      },
      {
        value: "Viber",
        label: "Viber",
      },
      {
        value: "WhatsApp",
        label: "WhatsApp",
      },
    ];
    
    const refreshPackagesDebounce = debounce(() => {
      refreshPackages();
    }, 500)

    watch(dataForm.cargoSpaceTabs, refreshPackagesDebounce);

    async function refreshPackages(index = undefined) {
      tabRefreshPackages(index);
      tabRefreshTimePickup();
    }

    function checkSummer() {
      const month = new Date().getMonth();
      const isSummer = month >= 5 && month <= 7;
      return isSummer;
    }

    return {
      checkWarmTab: function() {
        return dataForm.packagesTabs[this.cargoSpaceTab.counter].typeOfPackagings.value ? (dataForm.packagesTabs[this.cargoSpaceTab.counter].typeOfPackagings.value.length == 0 || dataForm.packagesTabs[this.cargoSpaceTab.counter].typeOfPackagings.value?.every(item => { return item.title != "Термобокс"})) : true;
      },
      checkCashOnDeliveryTab() {
        return dataForm.services.cargoRedemption || dataForm.sender.cityFrom == "Алматы" || dataForm.consignee.cityTo == "Алматы"
      },
      warmPlaceChangeTab: function() {
        // НЕОБХОДИМО НА ПРОСЛУШКУ УПАКОВОК ОБНОВЛЯТЬ dataForm.warmPlace

        let selectedCargoTab = getCargoTabKey(dataForm.cargoSpaceData)

        let tab = dataForm.cargoSpaceTabs[selectedCargoTab]

        // Производим проверку на сушествование элемента в массиве упаковок
        if(!dataForm.packagesTabs[tab.counter].typeOfPackagings?.value.every(item => { return item.title != "Термобокс"})) {
          
          refreshPackages(18)

          // Если он Locked он добавится 2 раза надо исправлять
          if(dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroup.includes('Термобокс')) {
            if(dataForm.packagesTabs[tab.counter].typeOfPackagings?.value.every(item => { return item.title != "Термобокс"})[0]?.isRequired != true) {
              dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroup = dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroup.filter(item => { return item != "Термобокс" })
              dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroupIds = dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroupIds.filter(item => { return item != "18" })
            }
          } else {
            dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroup.push('Термобокс');
            dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroupIds.push(18)
          }
          
          dataForm.cargoOtherTabs[getOtherKey(tab.name)].warmPlace = !checkSummer() && dataForm.packagesTabs[getPackageKey(tab.name)].additionalPackagingGroup.includes("Термобокс");
        } else {
          
          // Иначе экстренно отключаем WarmPlace
          dataForm.cargoOtherTabs[getOtherKey(tab.name)].warmPlace = false;
        }
      },
      dataForm,
      debug: function (c) {
        console.log(c)
      },
      refreshPackages,
      natures,
      fnatures,
      getOtherKey,
      optionsWhoPaysTheRansom,
      communications,
      requiredNeeded,
      typeOfPackagings,
      checkIntersectionsTypesTab: function (types, typeName) {
        return !(
          dataForm.packagesTabs[getPackageKey(this.cargoSpaceTab.name)].additionalPackagingGroup.filter((type) =>
            types.includes(type)
          ).length ===  dataForm.packagesTabs[getPackageKey(this.cargoSpaceTab.name)].additionalPackagingGroup.length &&
          !(typeName == 'Стретч' && this.cargoSpaceTab.packageSpecs == '1')
        );
      },
      getPackagesRules: function(counter) {
        return [
          {
            validator: (rule, value, callback) => {
              const packagings = dataForm.packagesTabs[counter]?.typeOfPackagings?.value;
              if (!packagings || packagings.length === 0) { callback(); return; }
              const requiredItems = packagings.filter(el => el.isRequired);
              if (requiredItems.length === 0) { callback(); return; }
              const missingItems = requiredItems.filter(el => !value.includes(el.title));
              if (missingItems.length > 0) { callback(new Error(`Необходимо выбрать обязательные упаковки: ${missingItems.map(el => el.title).join(', ')}`)); return; }
              callback();
            },
            trigger: 'change',
          },
        ];
      },
      filterOptionsTab(query) { 
        if (query == "") fnatures.value = natures.value;
        fnatures.value = natures.value.filter(e => (e.title.toLowerCase().includes(query.toLowerCase()) || e.title.toLowerCase().includes('иное')))
      },
      getArrayOfRules,
      checkRedemption: function () {
        if (
          this.cargoSpaceTab.whoPaysTheRansom === "1" &&
          Number(this.cargoSpaceTab.cargoRedemptionSum) > 6000
        ) {
          this.cargoSpaceTab.cargoRedemptionSum = 6000;
        }
      },
    };
  },
};
